import type { ComponentType } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import { Spinner } from '@phosphor-icons/react';
import ROUTES from '../../../shared/constants/routes';
import { useIsFiscalAdvisor } from '../hooks/useIsFiscalAdvisor';

const FiscalAdvisorGate = ({ View }: { View: ComponentType }) => {
  const isFiscalAdvisor = useIsFiscalAdvisor();

  if (isFiscalAdvisor === null) {
    return (
      <div className='flex h-dvh items-center justify-center'>
        <Spinner size={24} className='animate-spin text-h-primary-50' />
      </div>
    );
  }

  if (!isFiscalAdvisor) return <Navigate to={ROUTES.ROOT} replace />;

  return <View />;
};

export const fiscalAdvisorRoutes: RouteObject[] = [
  {
    path: '/fiscal-advisor',
    lazy: async () => {
      const View = (await import('../views/FiscalAdvisorView')).default;
      const GatedFiscalAdvisorView = () => <FiscalAdvisorGate View={View} />;
      return { Component: GatedFiscalAdvisorView };
    },
  },
];
